export const ORDER_OCCASION_SELECT_LABEL = 'order.occasion.select.label';
export const ORDER_OCCASION_HEADER = 'order.occasion.header';
export const ORDER_OCCASION_ALERT = 'order.occasion.alert';
export const ORDER_OCCASION_OPTION_TITLE = 'order.occasion.option_title';
export const ORDER_OCCASION_EVENT_SELECT_LABEL =
  'order.occasion_event.select.label';
